// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ChatPanel.module.scss */
.ChatPanel-module-Root_2UA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 16px;
  /* stylelint-disable*/
  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 58.67%), linear-gradient(274.22deg, #f7f6fe 47.14%, #eee8fe 97.95%);
  /* stylelint-enable*/ }

.ChatPanel-module-sSize_1wE.ChatPanel-module-Root_2UA {
  max-width: 288px; }

.ChatPanel-module-sSize_1wE h1,
.ChatPanel-module-sSize_1wE h2 {
  font-size: 1.25rem; }

.ChatPanel-module-mSize_2Uz.ChatPanel-module-Root_2UA {
  max-width: 343px; }

.ChatPanel-module-lSize_3YZ.ChatPanel-module-Root_2UA {
  max-width: 586px; }

.ChatPanel-module-Title_u2d {
  margin-bottom: 10px;
  font-weight: 600;
  line-height: 1.3; }
  @media (max-width: 320px) {
    .ChatPanel-module-Title_u2d {
      font-size: 1rem;
      line-height: 1.25; } }

.ChatPanel-module-Preview_3hz {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 221px;
  margin-right: 15px; }

.ChatPanel-module-Chat_1jy {
  display: flex;
  flex-direction: column;
  min-width: 134px; }

.ChatPanel-module-Operator_2BM {
  display: flex;
  margin-bottom: 19px; }

.ChatPanel-module-Status_3AM {
  max-width: 96px;
  margin: 0;
  line-height: 1.1; }

.ChatPanel-module-Photo_192 {
  position: relative;
  margin-right: 10px; }

.ChatPanel-module-Online_MV4::after {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  content: '';
  border: 1px solid #f6f6ff;
  border-radius: 50%;
  background: #50e3c2; }

.ChatPanel-module-Image_3w_ {
  display: flex;
  overflow: hidden;
  width: 28px;
  height: 28px;
  border-radius: 50%; }

.ChatPanel-module-Button_2Vr {
  padding: 7px 12px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ChatPanel/ChatPanel.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+IAA+I;EAC/I,oBAAoB,EAAE;;AAExB;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,eAAe;MACf,iBAAiB,EAAE,EAAE;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;EACE,eAAe;EACf,SAAS;EACT,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE","sourcesContent":["/*  imported from ChatPanel.module.scss */\n.ChatPanel-module-Root_2UA {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-radius: 16px;\n  /* stylelint-disable*/\n  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 58.67%), linear-gradient(274.22deg, #f7f6fe 47.14%, #eee8fe 97.95%);\n  /* stylelint-enable*/ }\n\n.ChatPanel-module-sSize_1wE.ChatPanel-module-Root_2UA {\n  max-width: 288px; }\n\n.ChatPanel-module-sSize_1wE h1,\n.ChatPanel-module-sSize_1wE h2 {\n  font-size: 1.25rem; }\n\n.ChatPanel-module-mSize_2Uz.ChatPanel-module-Root_2UA {\n  max-width: 343px; }\n\n.ChatPanel-module-lSize_3YZ.ChatPanel-module-Root_2UA {\n  max-width: 586px; }\n\n.ChatPanel-module-Title_u2d {\n  margin-bottom: 10px;\n  font-weight: 600;\n  line-height: 1.3; }\n  @media (max-width: 320px) {\n    .ChatPanel-module-Title_u2d {\n      font-size: 1rem;\n      line-height: 1.25; } }\n\n.ChatPanel-module-Preview_3hz {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 221px;\n  margin-right: 15px; }\n\n.ChatPanel-module-Chat_1jy {\n  display: flex;\n  flex-direction: column;\n  min-width: 134px; }\n\n.ChatPanel-module-Operator_2BM {\n  display: flex;\n  margin-bottom: 19px; }\n\n.ChatPanel-module-Status_3AM {\n  max-width: 96px;\n  margin: 0;\n  line-height: 1.1; }\n\n.ChatPanel-module-Photo_192 {\n  position: relative;\n  margin-right: 10px; }\n\n.ChatPanel-module-Online_MV4::after {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 10px;\n  height: 10px;\n  content: '';\n  border: 1px solid #f6f6ff;\n  border-radius: 50%;\n  background: #50e3c2; }\n\n.ChatPanel-module-Image_3w_ {\n  display: flex;\n  overflow: hidden;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%; }\n\n.ChatPanel-module-Button_2Vr {\n  padding: 7px 12px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
